<div class="to-sign-cntr">

  <ct-search-filters [configuration]="filtersConfiguration" (filter)="filter($event)"></ct-search-filters>

  <ng-container *ngIf="items.length > 0; else emptyQuotationsTemplate">

    <app-cart-order *ngFor="let order of items" [configuration]="order" (refresh)="fetch()"></app-cart-order>

    <div class="zip-actions">

      <div class="actions">

        <button mat-raised-button color="primary" (click)="downloadZip()">
          <mat-icon>cloud_download</mat-icon> Scarica ZIP
        </button>

        <button mat-raised-button color="accent" (click)="openUploadDialog()">
          <mat-icon>cloud_upload</mat-icon> Carica ZIP
        </button>
    
      </div>
    </div>

  </ng-container>

  <ng-template #emptyQuotationsTemplate>
    <p class="text-center">Non ci sono documneti da firmare.</p>
  </ng-template>

</div>